import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { X, Crown } from "@phosphor-icons/react";

/**
 * Shows only when the user is on the 'trial' plan AND has ≤3 days remaining.
 * Renders below the VerifyBanner so verification stays the higher-priority message.
 */
export default function TrialBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);

  if (!user || dismissed) return null;
  if (user.plan !== "trial") return null;
  const days = user.days_remaining;
  if (days === null || days === undefined || days > 3) return null;

  const urgency = days <= 1 ? "ends today" : `ends in ${days} days`;

  return (
    <div
      className="bg-foreground text-background border-b border-foreground"
      data-testid="trial-banner"
    >
      <div className="max-w-screen-2xl mx-auto px-6 py-2.5 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <Crown size={16} weight="fill" className="shrink-0 text-[hsl(var(--accent))]" />
          <div className="text-xs sm:text-sm font-mono leading-snug">
            <span className="font-bold uppercase tracking-widest mr-2">Free trial {urgency}.</span>
            <span className="opacity-80">Pick a plan to keep your stories, projects and Jira push.</span>
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Link
            to="/pricing"
            data-testid="trial-banner-cta"
            className="inline-flex items-center bg-[hsl(var(--accent))] text-white h-8 px-3 font-mono text-[10px] uppercase tracking-widest hover:bg-background hover:text-foreground transition-colors"
          >
            See plans →
          </Link>
          <button
            onClick={() => setDismissed(true)}
            className="text-background/70 hover:text-background"
            data-testid="trial-banner-dismiss"
            title="Dismiss"
          >
            <X size={14} weight="bold" />
          </button>
        </div>
      </div>
    </div>
  );
}
